import { render, staticRenderFns } from "./VacancyCandidatesKanbanStage.vue?vue&type=template&id=77edca63&scoped=true&"
import script from "./VacancyCandidatesKanbanStage.vue?vue&type=script&lang=js&"
export * from "./VacancyCandidatesKanbanStage.vue?vue&type=script&lang=js&"
import style0 from "./VacancyCandidatesKanbanStage.vue?vue&type=style&index=0&id=77edca63&lang=scss&scoped=true&"
import style1 from "./VacancyCandidatesKanbanStage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77edca63",
  null
  
)

/* custom blocks */
import block0 from "./VacancyCandidatesKanbanStage.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyCandidatesKanbanStage.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu,VTextField})
